module.exports = __webpack_public_path__ + "static/fallback_hero-b790612b93192b660bb99260d853fc8c.png";